import { render, staticRenderFns } from "./PassengerTransportationPermissionCostCenterInput.vue?vue&type=template&id=3c3e5472"
import script from "./PassengerTransportationPermissionCostCenterInput.vue?vue&type=script&lang=ts"
export * from "./PassengerTransportationPermissionCostCenterInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports